
import Vue from 'vue'

interface Data {
  cid: string | null
}

export default Vue.extend({
  data: (): Data => ({
    cid: null
  }),

  created() {
    this.fetchCID()
  },

  methods: {
    async fetchCID(): Promise<void> {
      await this.$ipfs.waitUntil('started')

      if (!this.$ipfs.api) {
        throw new Error('IPFS API undefined!')
      }

      const cidPath = await this.$ipfs.api.dns('www.dreamlink.cloud')

      this.cid = cidPath.substring(6)
    }
  }
})
